var map = {
	"./airtel.png": 422,
	"./facebook.png": 423,
	"./footer-client-logo2.png": 424,
	"./footer-client-logo4.png": 425,
	"./footer-client-logo5.png": 426,
	"./footer-clutch-logo.png": 427,
	"./footer-top-company-logo.png": 428,
	"./googlepartner.png": 429,
	"./ms.png": 430,
	"./softwareworld-badge.png": 431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 601;